<div class="loader-splash" *ngIf="adjusterService.loadInProcess || adjusterService.raiInProcess || adjusterService.clusteringInProcess">
  <div class="center-block">
    <h1 [hidden]="!adjusterService.loadInProcess">{{'ADJUSTER.loadingData' | translateHs: {app: 'default'} }}</h1>
    <h1 [hidden]="!adjusterService.raiInProcess">{{'ADJUSTER.calcAttractivity' | translateHs: {app: 'default'} }}</h1>
    <h1 [hidden]="!adjusterService.clusteringInProcess">{{'ADJUSTER.calcClusters' | translateHs: {app: 'default'} }}</h1>
    <div class="spinner-border spinner" role="status">
      <span class="visually-hidden">{{'ADJUSTER.loading' | translateHs: {app: 'default'} }}...</span>
    </div>
  </div>
</div>
